module.exports = __webpack_public_path__ + "static/background.eb569f6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Speakers/Background/background.svg
// module id = 713
// module chunks = 213534597649335